import React from 'react';

const Footer = () => {
    return (
        <div>&copy; 2020. Desenvolvimento URI-FW</div>
    );
}

export default Footer;
